/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1LocationStatesDropdownQueryResponse,
  GetApiV1LocationStatesDropdownQueryParams,
  GetApiV1LocationStatesDropdown401,
  GetApiV1LocationStatesDropdown500,
} from "../../types/locationStateController/GetApiV1LocationStatesDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1LocationStatesDropdown } from "../../clients/locationStateController/getApiV1LocationStatesDropdown.ts";

export const getApiV1LocationStatesDropdownQueryKey = (
  params?: GetApiV1LocationStatesDropdownQueryParams,
) =>
  [
    { url: "/api/v1/location/states/dropdown" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1LocationStatesDropdownQueryKey = ReturnType<
  typeof getApiV1LocationStatesDropdownQueryKey
>;

export function getApiV1LocationStatesDropdownQueryOptions(
  params?: GetApiV1LocationStatesDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1LocationStatesDropdownQueryKey(params);
  return queryOptions<
    GetApiV1LocationStatesDropdownQueryResponse,
    ResponseErrorConfig<
      GetApiV1LocationStatesDropdown401 | GetApiV1LocationStatesDropdown500
    >,
    GetApiV1LocationStatesDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1LocationStatesDropdown(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna estados ordenados por nome. Quando countryId é informado, filtra pelo país correspondente. **(Requer Authorization para autenticação)**
 * @summary Lista de estados/UFs para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/location/states/dropdown}
 */
export function useGetApiV1LocationStatesDropdown<
  TData = GetApiV1LocationStatesDropdownQueryResponse,
  TQueryData = GetApiV1LocationStatesDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1LocationStatesDropdownQueryKey,
>(
  params?: GetApiV1LocationStatesDropdownQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1LocationStatesDropdownQueryResponse,
        ResponseErrorConfig<
          GetApiV1LocationStatesDropdown401 | GetApiV1LocationStatesDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1LocationStatesDropdownQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1LocationStatesDropdownQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1LocationStatesDropdown401 | GetApiV1LocationStatesDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
